import React, { useState } from "react";
import { FcInfo } from "react-icons/fc";

function InfoBox({ name, description, category, type }) {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
      <div
        onClick={() => setShowInfo(!showInfo)}
        style={{ cursor: "pointer", marginRight: "8px", position: "relative" }}
      >
        <FcInfo size={20} />
        {showInfo && (
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "-220px",
              width: "220px",
              height: "150px",
              background: "#f9f9f9",
              border: "1px solid #ccc",
              padding: "10px",
              borderRadius: "6px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              zIndex: 100,
              overflowY: "auto",
              textAlign: "right",
              direction: "rtl",
              fontSize: "14px",
              lineHeight: "1.6"
            }}
          >
            <div style={{ fontSize: "16px", textAlign: "center", marginBottom: "5px" }}><strong>עסקה חוזרת</strong></div>
            <div><strong>שם:</strong> {name}</div>
            <div><strong>תיאור:</strong> {description}</div>
            <div><strong>קטגוריה משויכת:</strong> {category}</div>
            <div><strong>סוג:</strong> {type}</div>
          </div>
        )}
      </div>
    </div >
  );
}

export default InfoBox;
